import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Preloader from "../components/preloader/Preloader";
import OurQuestionSection from "../components/questioners/our_questions/OurQuestionSection";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";

class OurQuestions extends Component {
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    return (
      <React.Fragment>
        <div className="left-side-menu">
          <SideNavbar onClick={() => this.props.changeToggle()} />
        </div>
        <div className="content-page">
          <Preloader />
          <NavbarOne onClick={() => this.props.changeToggle()} />
          <div className="overlay" onClick={() => this.props.changeToggle()} />
          <div className="main-content">
            <OurQuestionSection />
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default OurQuestions;
